export default { type: 'email', message: 'Please enter a valid email address.' }
